type EncounterProps = {
  text: string;
  location: string;
}
export const Encounter: React.FC<EncounterProps> = ({ text, location }) => {
  if (!text) {
    return null;
  }
  const regex = /(Lore|Luck|Will|Fight|Speed|Sneak|Combat)\s+\(([+-]\d+)\)(?:\s*\[(\d+)\])?/g;
  const result = text.replaceAll(`${location} - `, '').replaceAll(regex, '<b>$&</b>');
  return (
    <div dangerouslySetInnerHTML={{ __html: result}} />
  );
}
